import { render } from "./SeniorMenu.vue?vue&type=template&id=7bfd31d0&scoped=true"
import script from "./SeniorMenu.vue?vue&type=script&lang=js"
export * from "./SeniorMenu.vue?vue&type=script&lang=js"

import "./SeniorMenu.vue?vue&type=style&index=0&id=7bfd31d0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bfd31d0"]])

export default __exports__